module.exports = __webpack_public_path__ + "img/dropdown-arrow.5f5a6b64.svg";